import { isEmpty } from 'remeda'
import { $settings } from './globals'

export interface Refinement {
  attribute: string
  value: string
}

/**
 * Generate a search URL that matches the format expected by the main search page.
 * This function creates URLs that are compatible with Algolia's default routing.
 * The search page specifically looks for 'refinementList' in the URL to activate search on page load.
 */
export const generateSearchUrl = (
  query?: string,
  refinements?: Refinement[],
): string => {
  // Get the index name from settings
  const indexName = $settings.algolia_index_name || 'products'

  // If no query and no refinements, return basic search page
  if (!query && (!refinements || isEmpty(refinements))) {
    return '/search'
  }

  const params = new URLSearchParams()

  // Add the search query if provided
  if (query) {
    params.set(`${indexName}[query]`, query)
  }

  // Add refinements if provided
  if (refinements && !isEmpty(refinements)) {
    refinements.forEach((refinement, index) => {
      params.set(
        `${indexName}[refinementList][${refinement.attribute}][${index.toString()}]`,
        refinement.value,
      )
    })
  }

  return `/search?${params.toString()}`
}
